import { render, staticRenderFns } from "./RegistroPatronal.vue?vue&type=template&id=ae04ccc2&scoped=true"
import script from "./RegistroPatronal.vue?vue&type=script&lang=js"
export * from "./RegistroPatronal.vue?vue&type=script&lang=js"
import style0 from "./RegistroPatronal.vue?vue&type=style&index=0&id=ae04ccc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae04ccc2",
  null
  
)

export default component.exports